<div class="flex flex-col gap-y-8 justify-start items-stretch m-4 w-80">
  <button
    mat-icon-button
    class="place-self-end"
    (click)="closePressed.emit()"
    data-cy="close-filter"
  >
    <mat-icon>close</mat-icon>
  </button>
  <form [formGroup]="filterForm" class="flex flex-col gap-y-8 basis-full">
    <div>
      <label>Display</label>
      <mat-radio-group formControlName="mode" class="flex flex-col gap-y-2">
        <mat-radio-button value="all" data-cy="all">All</mat-radio-button>
        <mat-radio-button value="transport" data-cy="transport"
          >Transport jobs only</mat-radio-button
        >
      </mat-radio-group>
    </div>
    <mat-form-field>
      <mat-select formControlName="category" placeholder="Select Category">
        <mat-option data-cy="test">All Categories</mat-option>
        <mat-option
          *ngFor="let category of categories$ | async"
          [value]="category.id"
          >{{ category.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="locations$ | async as locations">
      <mat-form-field *ngIf="locations.length > 1">
        <mat-select
          formControlName="location"
          placeholder="Location"
          data-cy="location"
        >
          <mat-option [value]="null">All locations</mat-option>
          <mat-option
            *ngFor="let location of locations"
            [value]="location.id"
            >{{ location.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </ng-container>

    <mat-checkbox formControlName="overdueOnly" data-cy="overdue"
      >Overdue only</mat-checkbox
    >

    <mat-checkbox formControlName="available" data-cy="available"
      >Show Available</mat-checkbox
    >
  </form>
</div>
